"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vuetify_1 = __importDefault(require("vuetify"));
require("vuetify/dist/vuetify.min.css");
var vuetify = new vuetify_1.default({
    breakpoint: {
        mobileBreakpoint: "sm",
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: "#041c2c",
                secondary: "#6DACDE",
                accent: "#FCAF17",
                background: "#EFEFEF",
            },
        },
    },
});
vue_1.default.use(vuetify_1.default);
exports.default = vuetify;
